import { render, staticRenderFns } from "./lowPriceNoRealTimeOperateAdmin.vue?vue&type=template&id=32d89f8f&scoped=true"
import script from "./lowPriceNoRealTimeOperateAdmin.vue?vue&type=script&lang=js"
export * from "./lowPriceNoRealTimeOperateAdmin.vue?vue&type=script&lang=js"
import style0 from "./lowPriceNoRealTimeOperateAdmin.vue?vue&type=style&index=0&id=32d89f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d89f8f",
  null
  
)

export default component.exports